import { ModelBase } from './ModelBase'

export class LogAccessiModel extends ModelBase {
    public LastLogin: Date
    public LastLogout: Date
}

export class ListaAccessiModel extends ModelBase {
    public ListaAccessi: Array<LogAccessiModel>
}